import styled, { css } from 'styled-components'

import { media, spacing } from '../../../../themes'

interface ContainerProps {
  centered: boolean
  padded: boolean
}

export const Container = styled.div<ContainerProps>`
  ${({ centered }) =>
    centered &&
    css`
      display: flex;
      justify-content: center;
    `}

  ${({ padded }) =>
    padded &&
    css`
      padding: ${spacing(6, 4)};

      ${media.pc} {
        padding: ${spacing(6)};
      }
    `}
`
